import Api from "../../Api";

export const validatePortName = async (portName) => {
  try {
    let res = await Api.get(`/ship-itineraries/validate-port-name/${portName}`);
    if (res?.data?.status) {
      return res.data.data;
    } else {
      return { error: res?.data?.message || "Invalid port name" };
    }
  } catch (e) {
    return { error: e?.response?.data?.message || "Something Wrong" };
  }
};

export const fetchAllPorts = async () => {
  try {
    let res = await Api.get(`/ship-itineraries/ports`);
    if (res?.data?.status) {
      return res.data.data || [];
    }
    return [];
  } catch (e) {
    return [];
  }
};